import { useNavigate } from 'react-router-dom'
import { MyCasesCard } from '@/app/dashboard/widgets'
import { useMyCases } from '../hooks'
import { STATUS_LABEL, STATUS_VARIANT } from '../status'

/**
 * Widget pulpitu „Moje sprawy" (prawa kolumna, jak w `design/screens/design-main.png`).
 *
 * Rdzeniowy `Dashboard.tsx` renderuje własną — pustą — kartę „Moje sprawy" nad widgetami
 * modułów (marker DASHBOARD-DATA). Nie możemy jej podmienić bez edycji rdzenia, więc
 * dokładamy kartę wypełnioną danymi z `GET /api/cases/my`.
 */
export function MyCasesWidget() {
  const navigate = useNavigate()
  const { data, isPending } = useMyCases(5)

  return (
    <MyCasesCard
      loading={isPending}
      moreHref="/sprawy"
      items={(data ?? []).map((item) => ({
        id: item.id,
        signature: item.signature,
        title: item.title,
        status: { label: STATUS_LABEL[item.status], variant: STATUS_VARIANT[item.status] },
        onClick: () => navigate(`/sprawy/${item.id}`),
      }))}
    />
  )
}
